import { ensureHandwritingFonts } from './siteHandwriting';
import { getSharedView } from './viewShareSite';
import { loadExhibitionImage } from './exhibitionImage';

let pending = null;

// One handoff belongs to the entrance currently being approached. Consume it
// on arrival so later visits still check the saved View's current visibility.
export function prepareMuseumVisit(id) {
  if (pending?.id === id && Date.now()-pending.createdAt<300000) return pending.promise;
  const visit = { id, createdAt:Date.now(), value:null, promise:null };
  pending = visit;
  visit.promise = Promise.all([
    getSharedView(id),
    fetch('/assets/view-index.json', { cache:'no-cache' }).then(response => {
      if (!response.ok) throw new Error('Source comparison unavailable');
      return response.json();
    }).catch(() => null),
    import(/* webpackChunkName: "view-exhibition" */ '../components/view/ViewExhibition.vue'),
    import(/* webpackChunkName: "view-exhibition-scene" */ './exhibitionScene'),
    import(/* webpackChunkName: "view-exhibition-model" */ './viewExhibition'),
    document.fonts.ready,
  ]).then(async ([snapshot, sourceIndex,,, exhibitionModel]) => {
    const sourceMap = new Map((snapshot.sources || []).map(source => [source.source_id, source]));
    const exhibition = exhibitionModel.createViewExhibition(snapshot.view, id => sourceMap.get(id));
    const firstRoomStops = (exhibition.rooms[0]?.stopIndices || []).filter(index => exhibition.stops[index]?.kind !== 'globe');
    const priority = new Set([
      snapshot.view?.illustration?.src,
      ...firstRoomStops.flatMap(index => [exhibition.stops[index]?.componentPreview?.src, ...(exhibition.stops[index]?.images || []).map(image => image.src)]),
    ].filter(Boolean));
    // Decode during the approach without holding the entrance on image IO.
    priority.forEach(src => { loadExhibitionImage(src).catch(() => {}); });
    // The scene warms its visible display images after mounting. Linked albums
    // and globe photographs are loaded only when the visitor opens that work.
    await ensureHandwritingFonts(snapshot.view?.question);
    visit.value = { snapshot, sourceIndex };
    return visit.value;
  }).catch(error => {
    if (pending === visit) pending = null;
    throw error;
  });
  return visit.promise;
}

export function takePreparedMuseumVisit(id) {
  if (pending?.id !== id || !pending.value) return null;
  const value = pending.value;
  pending = null;
  return value;
}
